import { findIndex } from 'lodash-es';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import AddPayment from '../../components/addPayment';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import localStorageUtil from '../../services/localStorageUtil/localStorageUtil';
import util from '../../shared/util';
import tlp from './payMethod.vue';
@Component({
    name: 'DefaultSelect',
    mixins: [tlp],
    components: {
        UnisProductModal,
        AddPayment,
    },
    filters: {
        filtersName(value: any, filterKey: any) {
            if (value[filterKey]) return value[filterKey];
            else return value;
        },
    },
})
export default class PayMethod extends Vue {
    selectdata: any = [];
    searchParams: any = {
        companyName: '',
    };
    editProductModal: string = 'addPayMethodDom';

    @Prop({
        default: '',
    })
    quoteId: any;

    @Prop({
        default: '',
    })
    orderId: any;

    @Prop({
        default: '',
    })
    placeholder: string;

    @Prop({
        default: '',
    })
    value: any;

    @Prop({
        default: '',
    })
    filterKey: string;

    @Prop({
        default: '',
    })
    billToId: string;

    @Prop({
        default: '',
    })
    applyAmount: string;

    @Prop({
        default: [],
    })
    invoiceIdAry: Array<any>;

    @Prop({
        default: false,
    })
    refresh: boolean;

    @Prop({
        default: false,
    })
    allowClear: boolean;

    @Prop({
        default: false,
    })
    error: any;

    priSelectdata: Array<any> = [];
    isFocused: boolean = false;
    isSelect: boolean = false;
    isHandleBin: boolean = false;
    transitionValue: any = '';
    inputData = '';
    editPayment: any = '';

    @Watch('error')
    getError(val: any, oldVal: any) {}

    @Watch('value')
    getValue(val: any, oldVal: any) {
        if (!val) {
            this.transitionValue = '';
        } else {
            // this.assignmentTransitionValue(val);\
            this.transitionValue = val;
        }
    }

    @Watch('inputData')
    getInputData(val: any, oldVal: any) {
        this.searchParams.companyName = val;
        this.getpayMethodList();
    }

    // @Watch('refresh')
    // refreshPayMethodList() {
    //   if (this.refresh) {
    //     this.getpayMethodList();
    //   }
    // }

    private assignmentTransitionValue(value: any) {
        this.selectdata.forEach((data: any) => {
            if (value == data[this.filterKey] || data.default_payment_method) {
                this.transitionValue = data;
                this.$emit('input', data);
                this.$emit('emitChoose', data);
            }
        });
    }

    mounted() {
        this.concatPayMents();
    }

    private concatPayMents(meitpayments: any = null) {
        this.priSelectdata = [];
        this.selectdata = this.selectdata.concat({
            payment_method: 'Paypal',
            text_1: 'PayPal',
        });
        let payMents = util.Base64DncodeForArray(
            localStorageUtil.getItemFromStorage(util.Base64EncodetoString('AddPayMents'))
        );
        if (!payMents) {
            this.priSelectdata = [
                {
                    payment_method: 'Paypal',
                    text_1: 'PayPal',
                },
            ];
        } else {
            if (payMents.length > 0) {
                this.priSelectdata = payMents.concat({
                    payment_method: 'Paypal',
                    text_1: 'PayPal',
                });
            } else
                this.priSelectdata = [
                    {
                        payment_method: 'Paypal',
                        text_1: 'PayPal',
                    },
                ];
        }
        if (meitpayments) {
            this.isSelect = false;
            this.isFocused = false;
            this.isHandleBin = false;
            this.transitionValue = meitpayments;
            this.$forceUpdate();
            this.$emit('input', meitpayments);
            this.$emit('emitChoose', meitpayments);
        }

        this.$forceUpdate();
    }

    getpayMethodList() {
        tmsServiceBackend
            .post(`/payment/getPaymentMethodList?billto_id=${this.billToId}&create_from=CLIENT`)
            .then(
                (res: any) => {
                    this.selectdata = res.data.data;
                    this.selectdata = this.selectdata.concat({
                        payment_method: 'Paypal',
                        text_1: 'PayPal',
                    });
                    this.assignmentTransitionValue(this.value);
                    if (this.selectdata) this.priSelectdata = this.selectdata;
                },
                (err: any) => {
                    console.log(err);
                }
            );
    }

    addNewPayment(payment: any) {
        this.concatPayMents(payment);
        this.closeModal();
    }

    closeModal() {
        this.$modal.hide(this.editProductModal);
    }

    handleFocus() {
        this.isFocused = true;
        this.isHandleBin = true;
        this.isSelect = true;
    }

    handleBlur(isValidate: any) {
        this.isSelect = false;
        this.isFocused = false;
        this.isHandleBin = false;
    }
    onItemSelect(item: any) {
        this.isSelect = false;
        this.isFocused = false;
        this.isHandleBin = false;
        this.transitionValue = item;
        this.$forceUpdate();
        this.$emit('input', item);
        this.$emit('emitChoose', item);
    }
    addPayMethod() {
        this.$emit('emitPayMethod', true);
        this.editPayment = {};
        this.editProductModal = 'addPayMethodDom';
        this.$modal.show(this.editProductModal);
    }

    onAllowClear() {
        this.transitionValue = null;
        this.$emit('input', null);
    }
    removePayMethod(item: any, index: any) {
        let payMents = util.Base64DncodeForArray(
            localStorageUtil.getItemFromStorage(util.Base64EncodetoString('AddPayMents'))
        );
        let cardNumberIndex = findIndex(payMents, { creation_time: item.creation_time });

        if (cardNumberIndex > -1) {
            payMents.splice(cardNumberIndex, 1);
        }
        localStorage.removeItem(util.Base64EncodetoString('AddPayMents'));
        if (payMents.length > 0) {
            localStorage.setItem(
                util.Base64EncodetoString('AddPayMents'),
                JSON.stringify(util.Base64EncodeForArray(payMents))
            );
        }
        this.concatPayMents();
    }
    editPayMethod(item: any) {
        this.$emit('emitPayMethod', true);
        this.editPayment = item;
        this.editProductModal = 'addPayMethodDom';
        this.$modal.show(this.editProductModal);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/payMethod/index.ts